import { LogAttributes, LogRecord, SeverityNumber } from '@opentelemetry/api-logs';
import {
    ATTR_EXCEPTION_MESSAGE,
    ATTR_EXCEPTION_STACKTRACE,
    ATTR_EXCEPTION_TYPE
} from '@opentelemetry/semantic-conventions';

import type { AdditionalLogproperties, SpaLogLevel } from '../logger.types';

export class LogUtil {
    static createLogRecord(
        severityNumber: SeverityNumber,
        body: string,
        loggerName: string,
        additionalLogproperties: AdditionalLogproperties
    ): Required<LogRecord> {
        const attributes: LogAttributes = {};
        const exception = additionalLogproperties?.exception;
        if (exception instanceof Error) {
            attributes[ATTR_EXCEPTION_MESSAGE] = exception.message;
            attributes[ATTR_EXCEPTION_STACKTRACE] = exception.stack;
            attributes[ATTR_EXCEPTION_TYPE] = exception.name;
        } else if (exception) {
            attributes[ATTR_EXCEPTION_MESSAGE] = this.#stringifyException(exception);
        }
        attributes['corrId'] = additionalLogproperties?.corrId;
        attributes['label'] = additionalLogproperties?.loggerName || loggerName;

        attributes['source_page'] = window.location.href;
        return {
            // TODO timestamp should not be set, open telemetry should do it for us
            timestamp: Date.now(),
            body,
            severityNumber,
            severityText: this.#toSeverityText(severityNumber),
            attributes
        } as Required<LogRecord>;
    }

    static #stringifyException(exception: unknown): string | undefined {
        if (typeof exception === 'string' || !exception) {
            return exception as string;
        }
        if (typeof exception !== 'object') {
            return JSON.stringify(exception);
        }
        return JSON.stringify(
            (Object.getOwnPropertyNames(exception) as (keyof object)[]).map(key => ({ [key]: exception[key] }))
        );
    }

    static #toSeverityText(severityNumber: SeverityNumber): SpaLogLevel {
        switch (severityNumber) {
            case SeverityNumber.TRACE:
                return 'trace';
            case SeverityNumber.DEBUG:
                return 'debug';
            case SeverityNumber.INFO:
                return 'info';
            case SeverityNumber.WARN:
                return 'warn';
            case SeverityNumber.ERROR:
                return 'error';
            default:
                throw new Error(`Unknown severity number '${severityNumber}'`);
        }
    }
}
